import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "hidden"
}

import BuilderComponent, { Row } from '@/components/Builder/BuilderComponent.vue'
import { computed } from 'vue'

type Props = {
  width?: string
  rows?: Row[]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MapPopupNew',
  props: {
    width: {},
    rows: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "7e96ad7f": (props.width ?? "200px")
}))

const props = __props

const interactable = computed(
  () => props.rows?.some((row) => row.cols?.some((c) => c.type === 'button') ?? false) ?? false
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (interactable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (props.rows)
      ? (_openBlock(), _createBlock(BuilderComponent, _mergeProps({
          key: 1,
          rows: props.rows
        }, _ctx.$attrs), null, 16, ["rows"]))
      : _createCommentVNode("", true)
  ]))
}
}

})